<script setup lang="ts"></script>

<template>
  <div class="next-month-day-tile-view" />
</template>

<style scoped lang="scss">
.next-month-day-tile-view {
  width: var(--calendar-tile-size);
  height: var(--calendar-tile-size);
}
</style>
